import moment from "moment";
import UserAvatar from "../../components/common/UserAvatar";

const licenseHistoryColumns = [
  {
    title: "User",
    dataIndex: "user_details",
    key: "user_details",
    render: (text, record) => <UserAvatar data={record?.user} />,
    fixed: "left",
  },
  {
    title: "License",
    dataIndex: "license_details",
    key: "license_details",
    render: (text, record) => (
      <span>{record?.license?.domain_name || "--"}</span>
    ),
  },
  {
    title: "Old Plan Period",
    dataIndex: "old_period",
    key: "old_period",
    render: (text, record) => (
      <div className="flex flex-col text-sm">
        <span>
          Start Date:{" "}
          {record?.old_start_date
            ? moment(record?.old_start_date).format("ll")
            : "--"}
        </span>
        <span>
          End Date:{" "}
          {record?.old_end_date
            ? moment(record?.old_end_date).format("ll")
            : "--"}
        </span>
      </div>
    ),
  },
  {
    title: "New Plan Period",
    dataIndex: "new_period",
    key: "new_period",
    render: (text, record) => (
      <div className="flex flex-col text-sm">
        <span>
          Start Date:{" "}
          {record?.new_start_date
            ? moment(record?.new_start_date).format("ll")
            : "--"}
        </span>
        <span>
          End Date:{" "}
          {record?.new_end_date
            ? moment(record?.new_end_date).format("ll")
            : "--"}
        </span>
      </div>
    ),
  },
  {
    title: "Plan Details",
    dataIndex: "plan_details",
    key: "plan_details",
    render: (text, record) => (
      <div className="flex flex-col text-sm">
        {record?.plan_details ? (
          <>
            {record?.plan_details?.name && (
              <span className="font-semibold">
                {record?.plan_details?.name}
              </span>
            )}
            {record?.plan_details?.amount && (
              <span>Amount: {record?.plan_details?.amount}</span>
            )}
            {record?.plan_details?.duration && (
              <span>
                Duration: {record?.plan_details?.duration} Month
                {record?.plan_details?.duration > 1 ? "s" : ""}
              </span>
            )}
          </>
        ) : (
          "--"
        )}
      </div>
    ),
  },
  {
    title: "Status",
    dataIndex: "new_status",
    key: "new_status",
    render: (status) => (
      <span
        className={`px-2 py-1 rounded-full text-xs font-semibold capitalize ${
          status === "active"
            ? "bg-green-100 text-green-700"
            : "bg-red-100 text-red-700"
        }`}
      >
        {status || "--"}
      </span>
    ),
  },
  {
    title: "Notes",
    dataIndex: "notes",
    key: "notes",
    width: 200,
    render: (text) => (
      <span className="text-sm text-gray-600 line-clamp-2" title={text}>
        {text || "--"}
      </span>
    ),
  },
];

export default licenseHistoryColumns;
